import { TableColumnType } from 'src/generated/graphql';

type TableColumnTypeRecord = Record<TableColumnType, boolean>;

export const labelTypes = {
  [TableColumnType.Link]: true,
  [TableColumnType.Lookup]: true,
  [TableColumnType.Labels]: true,
} as TableColumnTypeRecord;

export const statusTypes = {
  [TableColumnType.Status]: true,
  [TableColumnType.Dropdown]: true,
} as TableColumnTypeRecord;

export const functionTypes = {
  [TableColumnType.Number]: true,
  [TableColumnType.Function]: true,
} as TableColumnTypeRecord;
